import { useSelector } from 'react-redux';
import { LoadInitialData } from '../component';
import Dashboard from './dashboard';
import ServerDown from '../component/server_down';
const Route = () => {
  // eslint-disable-next-line no-unused-vars

  const app = useSelector((state: any) => state.app);
  const { isServerDown = false } = app;

  return (
    <>
      {isServerDown ? <ServerDown /> : <Dashboard />}
      <LoadInitialData />
    </>
  );
};

export default Route;
